import { MultiFileViewController } from './multi-file-view.controller';
import { MultiFileViewProps } from './multi-file-view.model';

const MultiFileView = (props: MultiFileViewProps): JSX.Element => {
  return <MultiFileViewController {...props} />;
};
export default MultiFileView;
